import React, { useState } from 'react'
import '../Dashboard/Dashboard.css'
import * as Yup from 'yup'
import {
    mapData,
    dateFormatFunction,
    handleRedirectInternal,
} from '@/product/common/components'
import Layout from '@/product/components/templates/Layout'
import ReportComponent from '@/product/views/Report/ReportComponent'

const ReportManagement = () => {
    const [state, setState] = useState({})

    const additionalfieldUpdate = (payload) => {
        setState(payload)
    }

    const allSearchOptions = [
        { id: 'within', description: 'Within' },
        { id: 'customSelection', description: 'Custom Selection' },
    ]

    const validation = Yup.object({
        order: Yup.string().required('Required!'),
        action: Yup.string().required('Required!'),
        report: Yup.string().required('Required!'),
        search: Yup.string().required('Required!'),
        start_date: Yup.date()
            .transform((value, originalValue) => {
                if (!originalValue) return null
                const [day, month, year] = originalValue.split('-')
                return new Date(`${year}-${month}-${day}`)
            })
            .required('Required!'),

        end_date: Yup.date()
            .transform((value, originalValue) => {
                if (!originalValue) return null
                const [day, month, year] = originalValue.split('-')
                return new Date(`${year}-${month}-${day}`)
            })
            .required('Required!')
            .min(Yup.ref('start_date'), 'End date must be equal or greater'),
        template_name: Yup.string().when(['template'], {
            is: true,
            then: Yup.string().required('Required'),
        }),
    })

    const initialValues = {
        action: 'display',
        order: 'asc',
        orderby: '',
        search: 'within',
        report: 'active_user_management',
        within: 'day',
        page: 1,
        limit: 20,
        start_date: dateFormatFunction(new Date()),
        end_date: dateFormatFunction(new Date()),
        limit_results: '',
        searchterm: '',
        fields: [],
    }

    const searchInfo = {
        data: [
            {
                label: 'Search Term',
                placeholder: 'Enter Search Term',
                class: 'col-md-4 col-sm-6 col-12',
                type: 'text',
                name: 'searchterm',
            },
        ],
    }

    const report = {
        data: [
            {
                label: 'Report',
                placeholder: 'Enter Report',
                class: 'col-12',
                type: 'select',
                groupoptions: [
                    {
                        head: 'User management',
                        options: [
                            { value: 'active_user_management', show: 'Active' },
                            {
                                value: 'deactivate_user_management',
                                show: 'Deactive',
                            },
                            {
                                value: 'unverified_user_management',
                                show: 'Unverified',
                            },
                        ],
                    },
                    {
                        head: 'Product management',
                        options: [
                            { value: 'open_product_management', show: 'Open' },
                            {
                                value: 'ending_product_management',
                                show: 'Ending',
                            },
                            {
                                value: 'closed_product_management',
                                show: 'Closed',
                            },
                            { value: 'sold_product_management', show: 'Sold' },
                        ],
                    },
                    {
                        head: 'Auction management',
                        options: [
                            { value: 'open_auction_management', show: 'Open' },
                            {
                                value: 'ending_auction_management',
                                show: 'Ending',
                            },
                            {
                                value: 'closed_auction_management',
                                show: 'Closed',
                            },
                            { value: 'sold_auction_management', show: 'Sold' },
                        ],
                    },
                    {
                        head: 'Sold Order management',
                        options: [{ value: 'sold_order', show: 'Sold' }],
                    },
                    {
                        head: 'Invoice management',
                        options: [
                            { value: 'paid_invoice_management', show: 'Paid' },
                            {
                                value: 'unpaid_invoice_management',
                                show: 'Unpaid',
                            },
                        ],
                    },
                    {
                        head: 'Employee management',
                        options: [
                            {
                                value: 'employee_list',
                                show: 'Employee Details',
                            },
                        ],
                    },
                    {
                        head: 'Wallet management',
                        options: [
                            {
                                value: 'deposit_balance',
                                show: 'Wallet Details',
                            },
                        ],
                    },
                    {
                        head: 'Transaction management',
                        options: [
                            {
                                value: 'transaction_list',
                                show: 'Transaction Details',
                            },
                        ],
                    },
                    {
                        head: 'Reconcile Details',
                        options: [
                            {
                                value: 'payment_reconcile_reports',
                                show: 'Reconcile Report',
                            },
                        ],
                    },
                    {
                        head: 'all Paid Product Report',
                        options: [
                            {
                                value: 'all_paid_reports',
                                show: 'All Paid Product Details',
                            },
                        ],
                    },
                ],
                name: 'report',
            },
        ],
    }

    const limitResult = {
        data: [
            {
                label: 'Limit results',
                placeholder: 'Enter Limit results',
                type: '',
                class: 'col-12',
                name: 'limit_results',
            },
        ],
    }

    let fieldsToShow = []

    fieldsToShow = [
        {
            field: 'id',
            label: 'ID',
            sort: true,
            type: '',
            group: [
                'active_user_management',
                'deactivate_user_management',
                'unverified_user_management',
                'deposit_balance',
            ],
        },
        {
            field: 'username',
            label: 'User Id',
            sort: true,
            type: '',
            group: [
                'active_user_management',
                'deactivate_user_management',
                'unverified_user_management',
                'deposit_balance',
            ],
        },
        {
            field: 'first_name',
            label: 'First Name',
            type: '',
            group: [
                'active_user_management',
                'deactivate_user_management',
                'unverified_user_management',
                'deposit_balance',
            ],
        },
        {
            field: 'last_name',
            label: 'Last Name',
            type: '',
            group: [
                'active_user_management',
                'deactivate_user_management',
                'unverified_user_management',
                'deposit_balance',
            ],
        },
        {
            field: 'email',
            label: 'User Email',
            sort: true,
            type: '',
            group: [
                'active_user_management',
                'deactivate_user_management',
                'unverified_user_management',
                'deposit_balance',
            ],
        },
        {
            field: 'phone',
            label: 'Phone Number',
            type: '',
            group: [
                'active_user_management',
                'deactivate_user_management',
                'unverified_user_management',
                'deposit_balance',
            ],
        },
        {
            field: 'companyname',
            label: 'Company Name',
            type: '',
            group: [
                'active_user_management',
                'deactivate_user_management',
                'unverified_user_management',
            ],
        },
        {
            field: 'job_title',
            label: 'Job Title',
            type: '',
            group: [
                'active_user_management',
                'deactivate_user_management',
                'unverified_user_management',
            ],
        },
        {
            field: 'membership_period',
            label: 'Membership Period',
            sort: true,
            type: '',
            group: [
                'active_user_management',
                'deactivate_user_management',
                'unverified_user_management',
            ],
        },
        {
            field: 'membership_amount',
            label: 'Membership Amount',
            sort: true,
            type: '',
            group: [
                'active_user_management',
                'deactivate_user_management',
                'unverified_user_management',
            ],
        },
        {
            field: 'membership_date',
            label: 'Membership Date',
            sort: true,
            type: 'datetime',
            group: [
                'active_user_management',
                'deactivate_user_management',
                'unverified_user_management',
            ],
        },
        {
            field: 'membership_end_date',
            label: 'Membership End Date',
            sort: true,
            type: 'datetime',
            group: [
                'active_user_management',
                'deactivate_user_management',
                'unverified_user_management',
            ],
        },
        {
            field: 'created_at',
            label: 'Created Date',
            sort: true,
            type: 'datetime',
            group: [
                'active_user_management',
                'deactivate_user_management',
                'unverified_user_management',
            ],
        },
        {
            field: 'last_login',
            label: 'Last Login',
            sort: true,
            type: 'datetime',
            group: [
                'active_user_management',
                'deactivate_user_management',
                'unverified_user_management',
            ],
        },
        {
            field: 'status',
            label: 'Status',
            type: 'capitalize',
            group: [
                'active_user_management',
                'deactivate_user_management',
                'unverified_user_management',
                'deposit_balance',
            ],
        },
        {
            field: 'deposit_amount',
            label: 'Wallet Balance',
            type: 'price',
            group: ['deposit_balance'],
        },
        {
            field: 'id',
            label: 'ID',
            sort: true,
            type: '',
            group: [
                'open_product_management',
                'ending_product_management',
                'closed_product_management',
                'sold_product_management',
            ],
        },
        {
            field: 'title',
            label: 'Title',
            sort: true,
            type: '',
            group: [
                'open_product_management',
                'ending_product_management',
                'closed_product_management',
                'sold_product_management',
                'all_paid_reports',
                'sold_order',
            ],
        },
        {
            field: 'date_added',
            label: 'Starting Date',
            sort: true,
            type: 'datetime',
            group: [
                'open_product_management',
                'ending_product_management',
                'closed_product_management',
                'sold_product_management',
                'all_paid_reports',
            ],
        },
        {
            field: 'date_closed',
            label: 'End Date',
            sort: true,
            type: 'datetime',
            group: [
                'open_product_management',
                'ending_product_management',
                'closed_product_management',
                'sold_product_management',
                'all_paid_reports',
            ],
        },
        {
            field: 'auctionid',
            label: 'Auction ID',
            sort: true,
            type: '',
            group: [
                'open_auction_management',
                'ending_auction_management',
                'closed_auction_management',
                'sold_auction_management',
            ],
        },
        {
            field: 'auction_title',
            label: 'Auction Title',
            sort: true,
            type: 'capitalize',
            group: [
                'open_auction_management',
                'ending_auction_management',
                'closed_auction_management',
                'sold_auction_management',
                'all_paid_reports',
            ],
        },
        {
            field: 'auction_description',
            label: 'Auction Description',
            sort: true,
            type: 'capitalize',
            group: [
                'open_auction_management',
                'ending_auction_management',
                'closed_auction_management',
                'sold_auction_management',
            ],
        },
        {
            field: 'auction_date_added',
            label: 'Auction Starting Date',
            sort: true,
            type: 'date',
            group: [
                'open_auction_management',
                'ending_auction_management',
                'closed_auction_management',
                'sold_auction_management',
            ],
        },
        {
            field: 'auction_date_closed',
            label: 'Auction End Date',
            sort: true,
            type: 'date',
            group: [
                'open_auction_management',
                'ending_auction_management',
                'closed_auction_management',
                'sold_auction_management',
            ],
        },
        {
            field: 'auction_status',
            label: 'Auction Status',
            sort: true,
            type: 'capitalize',
            group: [
                'open_auction_management',
                'ending_auction_management',
                'closed_auction_management',
                'sold_auction_management',
            ],
        },
        {
            field: 'lot_id',
            label: 'Lot ID',
            sort: true,
            type: '',
            group: [
                'open_auction_management',
                'ending_auction_management',
                'closed_auction_management',
                'sold_auction_management',
            ],
        },
        {
            field: 'lot_title',
            label: 'Lot Title',
            sort: true,
            type: 'capitalize',
            group: [
                'open_auction_management',
                'ending_auction_management',
                'closed_auction_management',
                'sold_auction_management',
            ],
        },
        {
            field: 'lot_date_added',
            label: 'Lot Starting Date',
            sort: true,
            type: 'date',
            group: [
                'open_auction_management',
                'ending_auction_management',
                'closed_auction_management',
                'sold_auction_management',
            ],
        },
        {
            field: 'lot_date_closed',
            label: 'Lot End Date',
            sort: true,
            type: 'date',
            group: [
                'open_auction_management',
                'ending_auction_management',
                'closed_auction_management',
                'sold_auction_management',
            ],
        },
        {
            field: 'sprice',
            label: 'Starting Price',
            type: 'price',
            group: [
                'open_product_management',
                'ending_product_management',
                'closed_product_management',
                'sold_product_management',
                'all_paid_reports',
                'open_auction_management',
                'ending_auction_management',
                'closed_auction_management',
                'sold_auction_management',
            ],
        },
        {
            field: 'bprice',
            label: 'Buynow Price',
            type: 'price',
            group: [
                'open_auction_management',
                'ending_auction_management',
                'closed_auction_management',
                'sold_auction_management',
            ],
        },
        {
            field: 'qty',
            label: 'Total Quantity',
            type: '',
            group: [
                'open_auction_management',
                'ending_auction_management',
                'closed_auction_management',
                'sold_auction_management',
            ],
        },
        {
            field: 'sold',
            label: 'Sold Quantity',
            type: '',
            group: [
                'open_auction_management',
                'ending_auction_management',
                'closed_auction_management',
                'sold_auction_management',
            ],
        },
        {
            field: 'buynowamount',
            label: 'Sold Price',
            type: 'price',
            // countryfield: 'charity_country',

            group: [
                'sold_product_management',
                'all_paid_reports',
                'sold_order',
                'paid_invoice_management',
                'unpaid_invoice_management',
            ],
        },

        {
            field: 'wprice',
            label: 'Current Price',
            sort: true,
            type: 'price',
            // countryfield: 'charity_country',
            group: [
                'open_product_management',
                'ending_product_management',
                'closed_product_management',
                'open_auction_management',
                'ending_auction_management',
                'closed_auction_management',
                'sold_auction_management',
            ],
        },
        {
            field: 'market_status',
            label: 'Status',
            sort: true,
            type: 'capitalize',
            group: [
                'open_product_management',
                'ending_product_management',
                'closed_product_management',
                'sold_product_management',
                'all_paid_reports',
                'sold_order',
            ],
        },
        {
            field: 'totalbids',
            label: 'No. of Bids',
            type: '',
            group: [
                'open_product_management',
                'ending_product_management',
                'closed_product_management',
                'sold_product_management',
                'all_paid_reports',
                'sold_order',
                'open_auction_management',
                'ending_auction_management',
                'closed_auction_management',
                'sold_auction_management',
            ],
        },
        {
            field: 'numDiffBidders',
            label: 'No. of Different Bidders',
            type: '',
            group: [
                'open_product_management',
                'ending_product_management',
                'closed_product_management',
                'sold_product_management',
                'all_paid_reports',
                'sold_order',
            ],
        },
        {
            field: 'winnerName',
            label: 'Buyer Name',
            type: '',
            group: [
                'sold_product_management',
                'all_paid_reports',
                'sold_order',
                'paid_invoice_management',
                'unpaid_invoice_management',
            ],
        },
        {
            field: 'winemail',
            label: 'Winner Email',
            type: '',
            group: [
                'open_product_management',
                'ending_product_management',
                'closed_product_management',
            ],
        },
        {
            field: 'winnerEmail',
            label: 'Winner Email',
            type: 'capitalize',
            group: ['paid_invoice_management', 'unpaid_invoice_management'],
        },
        {
            field: 'winnerCompany',
            label: 'Buyer Company',
            type: 'capitalize',
            group: ['paid_invoice_management', 'unpaid_invoice_management'],
        },
        {
            field: 'buynowemail',
            label: 'Buyer Email',
            type: '',
            group: [
                'sold_product_management',
                'all_paid_reports',
                'sold_order',
            ],
        },
        {
            field: 'common_invoice',
            label: 'Invoice ID',
            sort: true,
            type: '',
            group: [
                'sold_product_management',
                'all_paid_reports',
                'sold_order',
                'paid_invoice_management',
                'unpaid_invoice_management',
                'transaction_list',
            ],
        },
        {
            field: 'paid_date',
            label: 'Paid Date',
            sort: true,
            type: 'datetime',
            group: ['sold_product_management', 'all_paid_reports'],
        },
        {
            field: 'shipping_amount',
            label: 'Shipping Price',
            sort: true,
            type: 'price',
            group: ['paid_invoice_management', 'unpaid_invoice_management'],
        },
        {
            field: 'total_invoice',
            label: 'Total Price',
            sort: true,
            type: 'price',
            group: ['paid_invoice_management', 'unpaid_invoice_management'],
        },
        {
            field: 'date_added',
            label: 'Sold Date',
            sort: true,
            type: 'date',
            group: ['paid_invoice_management', 'unpaid_invoice_management'],
        },
        {
            field: 'paid_date',
            label: 'Paid Date',
            sort: true,
            type: 'date',
            group: ['paid_invoice_management', 'unpaid_invoice_management'],
        },
        {
            field: 'project_id',
            label: 'Product ID',
            sort: true,
            type: '',
            group: ['sold_order'],
        },
        {
            field: 'sold_qty',
            label: 'Purchased Qty',
            sort: true,
            type: '',
            group: [
                'sold_order',
                'paid_invoice_management',
                'unpaid_invoice_management',
            ],
        },
        {
            field: 'date_added',
            label: 'Sale Date',
            sort: true,
            type: 'date',
            group: ['sold_order'],
        },
        {
            field: 'paid',
            label: 'Paid Status',
            sort: true,
            type: 'paid_status',
            group: [
                'sold_order',
                'paid_invoice_management',
                'unpaid_invoice_management',
            ],
        },
        {
            field: 'emp_firstname',
            label: 'First Name',
            sort: true,
            type: 'capitalize',
            group: ['employee_list'],
        },
        {
            field: 'emp_lastname',
            label: 'Last Name',
            sort: true,
            type: 'capitalize',
            group: ['employee_list'],
        },
        {
            field: 'emp_email',
            label: 'Email',
            sort: true,
            type: '',
            group: ['employee_list'],
        },
        {
            field: 'emp_phone',
            label: 'Phone Number',
            sort: true,
            type: '',
            group: ['employee_list'],
        },
        {
            field: 'emp_address1',
            label: 'Address',
            sort: true,
            type: 'capitalize',
            group: ['employee_list'],
        },
        {
            field: 'emp_city',
            label: 'City',
            sort: true,
            type: '',
            group: ['employee_list'],
        },
        {
            field: 'emp_zip',
            label: 'Zip Code',
            sort: true,
            type: '',
            group: ['employee_list'],
        },
        {
            field: 'emp_state',
            label: 'State',
            sort: true,
            type: '',
            group: ['employee_list'],
        },
        {
            field: 'emp_country',
            label: 'Country',
            sort: true,
            type: '',
            group: ['employee_list'],
        },
        {
            field: 'emp_type',
            label: 'Employee Type',
            sort: true,
            type: 'em_type',
            group: ['employee_list'],
        },
        {
            field: 'trans_id',
            label: 'Transaction ID',
            sort: true,
            type: '',
            group: ['transaction_list'],
        },
        {
            field: 'amount',
            label: 'Amount',
            sort: true,
            type: 'price',
            group: ['transaction_list'],
        },
        {
            field: 'user_fullname',
            label: 'Buyer Name',
            sort: true,
            type: 'capitalize',
            group: ['transaction_list'],
        },
        {
            field: 'email',
            label: 'Buyer Email',
            sort: true,
            type: '',
            group: ['transaction_list'],
        },
        {
            field: 'payment_method',
            label: 'Payment Type',
            sort: true,
            type: 'capitalize',
            group: ['transaction_list'],
        },
        {
            field: 'card_type',
            label: 'Gateway',
            sort: true,
            type: 'capitalize',
            group: ['transaction_list'],
        },
        {
            field: 'created_at',
            label: 'Paid Date',
            sort: true,
            type: 'datetime',
            group: ['transaction_list'],
        },
        {
            field: 'totalbids',
            label: 'No. of Bids',
            type: '',
            group: ['all_paid_reports'],
        },
        {
            field: 'bid_deposit_amount',
            label: 'Bid Deposit Amount',
            sort: true,
            type: '',
            group: ['all_paid_reports'],
        },
        {
            field: 'bid_deposit_status',
            label: 'Bid Deposit Status',
            sort: true,
            type: '',
            group: ['all_paid_reports'],
        },
        {
            field: 'bid_deposit_date_added',
            label: 'Bid Deposit Date Added',
            sort: true,
            type: 'datetime',
            group: ['all_paid_reports'],
        },
        {
            field: 'bid_deposit_gateway',
            label: 'Bid Deposit Gate Way',
            sort: true,
            type: '',
            group: ['all_paid_reports'],
        },
        {
            field: 'bid_refunded',
            label: 'Bid refended',
            sort: true,
            type: '',
            group: ['all_paid_reports'],
        },
        {
            field: 'sale_date',
            label: 'Sale Date',
            sort: true,
            type: 'datetime',
            group: ['payment_reconcile_reports'],
        },
        {
            field: 'sale_type',
            label: 'Sale Type',
            sort: true,
            type: '',
            group: ['payment_reconcile_reports'],
        },
        {
            field: 'common_invoice',
            label: 'Payment Invoice',
            sort: true,
            type: '',
            group: ['payment_reconcile_reports'],
        },
        {
            field: 'return_invoice',
            label: 'Return Invoice',
            sort: true,
            type: '',
            group: ['payment_reconcile_reports'],
        },
        {
            field: 'first_name',
            label: 'Customer First Name',
            sort: true,
            type: '',
            group: ['payment_reconcile_reports'],
        },
        {
            field: 'last_name',
            label: 'Customer Last Name',
            sort: true,
            type: '',
            group: ['payment_reconcile_reports'],
        },
        {
            field: 'email',
            label: 'Customer Email',
            sort: true,
            type: '',
            group: ['payment_reconcile_reports'],
        },
        {
            field: 'auction_title',
            label: 'Auction Title',
            sort: true,
            type: '',
            group: ['payment_reconcile_reports'],
        },
        {
            field: 'project_title',
            label: 'Project Title',
            sort: true,
            type: '',
            group: ['payment_reconcile_reports'],
        },
        {
            field: 'payment_method',
            label: 'Payment Method',
            sort: true,
            type: '',
            group: ['payment_reconcile_reports'],
        },
        {
            field: 'per_total',
            label: 'Item Subtotal',
            sort: true,
            type: 'price',
            group: ['payment_reconcile_reports'],
        },
        {
            field: 'total_tax',
            label: 'Sales Tax',
            sort: true,
            type: 'price',
            group: ['payment_reconcile_reports'],
        },
        {
            field: 'total_shipping',
            label: 'Shipping',
            sort: true,
            type: 'price',
            group: ['payment_reconcile_reports'],
        },
        {
            field: 'total_invoice',
            label: 'Total Paid',
            sort: true,
            type: 'price',
            group: ['payment_reconcile_reports'],
        },
        {
            field: 'charity_name',
            label: 'Charity name',
            sort: true,
            type: '',
            group: [
                'open_product_management',
                'ending_product_management',
                'closed_product_management',
                'sold_product_management',
            ],
        },
    ]

    return (
        <Layout>
            <ReportComponent
                orderSort={global?.orderSort ? global.orderSort : false}
                formFields={fieldsToShow}
                report={report}
                allSearchOptions={allSearchOptions}
                validationSchema={validation}
                limitResult={limitResult}
                initialValues={initialValues}
                additionalfieldUpdate={additionalfieldUpdate}
                searchInfo={searchInfo}
                customLabel="Customize your report using a wide variety of date range options."
                SubmitBtnLabel="Generate Report"
            />
        </Layout>
    )
}

export default ReportManagement
